import {defineMessages} from 'react-intl';

export default defineMessages({
	success: {
		id: 'productView.popup.addedToCart',
		defaultMessage: '<comment>Added to bag</comment><cta>View</cta>',
	},
	error: {
		id: 'common.error.general',
		defaultMessage: 'Oops! Something went wrong.',
	},
	quantityError: {
		id: 'productView.button.quantityError',
		defaultMessage: 'You have entered the maximum quantity available for this item'
	},
});
